import Home from './Pages/Home';
import { useEffect } from 'react';
import About from './Pages/about';
import Fleet from './Pages/fleet';
import Nav from './Components/navbar';
import Contact from './Pages/contact';
import Services from './Pages/services';
import NotFound from './Pages/notFound';
import Footer from './Components/Footer';
import ScrollToTop from './Components/ScrollToTopTwo';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// admin
import AdminLogin from "./Pages/Admin/AdminLogin";
import AdminMessages from "./Pages/Admin/AdminMessages";
import { AdminProvider } from "../src/context/AdminContext"
import { trackClick,initGA } from './ga';


function App() {
    useEffect(() => {
    initGA();
  }, []);
  return (
    <BrowserRouter>
      <AdminProvider>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/fleet" element={<Fleet />} />
        <Route path="/services" element={<Services />} />     
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
            <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      </AdminProvider>
    </BrowserRouter>
  );
}


export default App;